module.exports = __webpack_public_path__ + "img/service_img14.7191884f.png";